module.exports = __webpack_public_path__ + "img/madam.8a4dc64d.png";